import HttpClient from '@/common/http'

export default {
  /**
   * @param {Document} document
   * @returns {Promise}
   */
  Documents (document) {
    return HttpClient.api.post(`/documents`, document)
  },
  /**
   * @param {string} [name='']
   * @returns {Promise}
   */
  Get (name = '') {
    const params = {}

    if (String(name) !== '') {
      params.params = { name: name }
    }

    return HttpClient.api.get(`/documents`, params)
  },
  /**
   * @param {IdType} documentId
   * @returns {Promise}
   */
  GetDocument (documentId) {
    const params = {}

    return HttpClient.api.get(`/documents/${documentId}`, params)
  },
  /**
   * @param {Document} document
   * @returns {Promise}
   */
  Put (document) {
    delete document._expend
    return HttpClient.api.put(`/documents/${document.id}`, document)
  },
  /**
   * @param {File} file
   * @returns {Promise}
   */
  Files (file) {
    return HttpClient.api.post(`/files`, file, {
      headers: {
        'Content-Type': file.type
      }
    })
  },
  /**
   * @param {Document} document
   * @returns {Promise}
   */
  Delete (document) {
    return HttpClient.api.delete(`/documents/${document.id}`)
  }
}



// WEBPACK FOOTER //
// ./src/common/services/document.js